import { render, staticRenderFns } from "./icon-select.vue?vue&type=template&id=65a2eb4a&"
import script from "./icon-select.vue?vue&type=script&lang=js&"
export * from "./icon-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65a2eb4a')) {
      api.createRecord('65a2eb4a', component.options)
    } else {
      api.reload('65a2eb4a', component.options)
    }
    module.hot.accept("./icon-select.vue?vue&type=template&id=65a2eb4a&", function () {
      api.rerender('65a2eb4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/icon-select.vue"
export default component.exports